export const small = "@media (max-width: 600px)";
export const medium = "@media (max-width: 900px)";
